import React from "react";

// Import modular components
import HeroBanner from "../components/HeroBanner";
import TrustedLogos from "../components/TrustedLogos";
import ServicesOverview from "../components/ServicesOverview";
import CounterStats from "../components/CounterStats";
import Testimonials from "../components/Testimonials";
import CallToActionBanner from "../components/CallToActionBanner";

const HomePage = () => {
  return (
    <div className="text-gray-800">
      <HeroBanner />
      <TrustedLogos />
      <ServicesOverview />
      <CounterStats />
      <Testimonials />
      <CallToActionBanner />
    </div>
  );
};

export default HomePage;
